import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createReportesProviders = (ctx: TGlobalSearchProviderContext): ISearchProvider[] => {
    const reportesEventosAsistenciasProvider: ISearchProvider = {
        key: "reportes-eventos-asistencias",
        label: "Reportes: Asistencias",
        subLabel: "Reportes de asistencias por alumno",
        action: ctx.navigateModule("reportes/eventos--escs=0" as any), // FIXME Agregar soporte para que navigateModule acepte rutas con parámetros
        search: (): ISearchResult[] => ([]),
    };

    const reportesEventosProvider: ISearchProvider = {
        key: "reportes-eventos",
        label: "Reportes: Eventos",
        subLabel: "Consulta de eventos por alumno",
        action: ctx.navigateModule("reportes/eventos--escs=0" as any), // FIXME Agregar soporte para que navigateModule acepte rutas con parámetros
        search: (): ISearchResult[] => ([]),
    };

    const reportesEventosLogrosProvider: ISearchProvider = {
        key: "reportes-eventos-logros",
        label: "Reportes: Logros",
        subLabel: "Consulta de logros por alumno",
        action: ctx.navigateModule("reportes/logros"),
        search: (): ISearchResult[] => ([]),
    };

    return [
        reportesEventosAsistenciasProvider,
        reportesEventosProvider,
        reportesEventosLogrosProvider,
    ];
};
